import { Icon } from "@blueprintjs/core"
import React from "react"
import CustomStaticSelector from "components/Atoms/CustomStaticSelector"
import CustomTag from "components/Atoms/CustomTag"
import { useAuthorizationSimple } from "hooks/useAuthorizationStrict"
import { useAuthDcs, useCurrentDc } from "store/auth.redux"
import { useFilter } from "store/search-filter/search-filter.reducer"

const DCSelector = () => {
  const [dc, setDc] = useCurrentDc()
  const limitOrders = useAuthorizationSimple("vt_limit_orders_assigned_dc")

  const [filter, setFilter] = useFilter("dispatch")
  const [orderFilter, setOrderFilter] = useFilter("orders")
  const [ecommerceFilter, setEcommerceFilter] = useFilter("ecommerce")
  const availableDcs = useAuthDcs()
  return (
    <span
      style={{ backgroundImage: "/images/hero.png" }}
      className="em-dc-selector"
    >
      <Icon className="mx-2" icon="chevron-right" />
      <CustomStaticSelector
        className="mb-0"
        items={availableDcs}
        onChange={(_, value) => {
          setDc(value)
          if (limitOrders) {
            setFilter({ ...filter, distributionCentreIds: [value] })
            setOrderFilter({ ...orderFilter, distributionCentreIds: [value] })
          }
          setEcommerceFilter({
            ...ecommerceFilter,
            distributionCentreIds: [value],
          })
        }}
      >
        {() => {
          return (
            <CustomTag
              data-testid="distribution-center-dropdown"
              large
              className="d-center em-dc-selector-tag"
              interactive={true}
              minimal
              intent="primary"
            >
              {dc?.name ? dc?.name : "None"}
              <Icon className="ml-1" icon="chevron-down" iconSize={10} />
            </CustomTag>
          )
        }}
      </CustomStaticSelector>
    </span>
  )
}

export default DCSelector
